import { BusinessUnitShort } from 'src/@enums'
import { businessUnitCombined } from 'src/constants'

export const getBusinessUnitDescribed = (unit: `${BusinessUnitShort}`) => businessUnitCombined[unit]
